import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export default () => {
    document.addEventListener("DOMContentLoaded", function () {
        const blockTextLoop = document.querySelectorAll(
            ".blockTextLoop__slider"
        );

        if (blockTextLoop) {
            blockTextLoop.forEach((singleSlider) => {
                const splideIcons = new window.splide(singleSlider, {
                    pagination: false,
                    arrows: false,
                    gap: "8px",
                    type: "loop",
                    drag: "free",
                    focus: "center",
                    perPage: 5,
                    autoScroll: {
                        speed: 1,
                        pauseOnHover: false,
                    },
                    breakpoints: {
                        1224: {
                            perPage: 4,
                        },
                        767: {
                            perPage: 2,
                        },
                    },
                });

                splideIcons.mount({ AutoScroll });
            });
        }
    });
}